/** Canonical English product copy. Keys are stable API; values may be translated. */
const en = {
  'app.name': 'SpikeScope',
  'app.dashboardName': 'Spike Dashboard',

  'auth.login.subtitle': 'Sign in to your account',
  'auth.login.usernameLabel': 'Username or Email',
  'auth.login.usernamePlaceholder': 'Enter your username or email',
  'auth.login.passwordLabel': 'Password',
  'auth.login.passwordPlaceholder': 'Enter your password',
  'auth.login.submit': 'Sign In',
  'auth.login.submitting': 'Signing in...',
  'auth.login.failure': 'Login failed. Please check your credentials.',
  'auth.login.noAccount': "Don't have an account?",
  'auth.login.createAccount': 'Create one',

  'auth.register.subtitle': 'Create your account',
  'auth.register.usernameLabel': 'Username',
  'auth.register.usernamePlaceholder': 'Choose a username',
  'auth.register.emailLabel': 'Email',
  'auth.register.emailPlaceholder': 'Enter your email',
  'auth.register.passwordLabel': 'Password',
  'auth.register.passwordPlaceholder': 'Create a password',
  'auth.register.confirmPasswordLabel': 'Confirm Password',
  'auth.register.confirmPasswordPlaceholder': 'Confirm your password',
  'auth.register.submit': 'Create Account',
  'auth.register.submitting': 'Creating account...',
  'auth.register.failure': 'Registration failed. Please try again.',
  'auth.register.hasAccount': 'Already have an account?',
  'auth.register.signIn': 'Sign in',
  'auth.register.usernameRequirements': 'Username requirements',
  'auth.register.passwordRequirements': 'Password requirements',
  'auth.register.confirmationRequirements': 'Password confirmation requirements',
  'auth.validation.passwordsMatch': 'Passwords match',
  'auth.validation.usernameInvalid': 'Username does not meet the requirements',
  'auth.validation.emailInvalid': 'Please enter a valid email address',
  'auth.validation.passwordInvalid': 'Password does not meet the requirements',
  'auth.validation.passwordMismatch': 'Passwords do not match',
  'auth.requirements.length': '{min}-{max} characters',
  'auth.requirements.usernameCharacters': 'Letters, numbers, and underscores only',
  'auth.requirements.uppercase': 'At least one uppercase letter',
  'auth.requirements.lowercase': 'At least one lowercase letter',
  'auth.requirements.number': 'At least one number',
  'auth.requirements.symbol': 'At least one symbol',

  'widgets.bank.title': 'Widget Bank',
  'widgets.bank.searchPlaceholder': 'Search widgets...',
  'widgets.bank.all': 'All',
  'widgets.bank.dragHint': 'Drag widgets to the canvas or click to add another',
  'widgets.bank.noResults': 'No widgets found',
  'widgets.bank.activeCount': '{active} / {total} active',

  'widgets.categories.data.name': 'Data Tables',
  'widgets.categories.data.description': 'Widgets for viewing and browsing data',
  'widgets.categories.analysis.name': 'Analysis',
  'widgets.categories.analysis.description': 'Widgets for data analysis and statistics',
  'widgets.categories.visualization.name': 'Visualization',
  'widgets.categories.visualization.description': 'Widgets for data visualization and plotting',
  'widgets.categories.custom.name': 'Custom',
  'widgets.categories.custom.description': 'User-created custom widgets',

  'widgets.clusterList.name': 'Cluster Curation Table',
  'widgets.clusterList.description': 'Sort, filter, label, annotate, and select clusters across linked widgets',
  'widgets.spikeList.name': 'Spike List Table',
  'widgets.spikeList.description': 'Browse spike events chronologically',
  'widgets.clusterStats.name': 'Cluster Statistics',
  'widgets.clusterStats.description': 'ISI violations, spike counts, quality metrics',
  'widgets.signalView.name': 'Signal View',
  'widgets.signalView.description': 'Raw/filtered neural signal traces',
  'widgets.dimReduction.name': 'PCA Plot',
  'widgets.dimReduction.description': 'Dimensionality reduction visualization',
  'widgets.waveform.name': 'Waveform View',
  'widgets.waveform.description': 'Spike waveform overlays',
  'widgets.amplitudeProfile.name': 'Amplitude Distribution',
  'widgets.amplitudeProfile.description': 'Waveform amplitude histograms with Gaussian KDE overlays',
  'widgets.clusterComparison.name': 'Cluster Comparison',
  'widgets.clusterComparison.description': 'Compare spike-time agreement between two cluster sets',
  'widgets.curator.name': 'Curator',
  'widgets.curator.description': 'Review one cluster set and drive linked analysis widgets',
  'widgets.rasterPlot.name': 'Raster Plot',
  'widgets.rasterPlot.description': 'Compact spike-event raster grouped by cluster or channel',
  'widgets.correlogram.name': 'Correlogram Matrix',
  'widgets.correlogram.description': 'Auto- and cross-correlograms with refractory and baseline guides',
  'widgets.isiHistogram.name': 'ISI Histogram',
  'widgets.isiHistogram.description': 'Inter-spike intervals and refractory-period violation rates',
  'widgets.amplitudeTime.name': 'Amplitude vs Time / Drift',
  'widgets.amplitudeTime.description': 'Track raw spike amplitude through the recording and brush time ranges',
};

export default en;
